/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Sos_Dunning_OverInputs */

const en_queue_sos_dunning_over = /** @type {(inputs: Queue_Sos_Dunning_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales orders not paid after the last reminder`)
};

/**
* | output |
* | --- |
* | "Sales orders not paid after the last reminder" |
*
* @param {Queue_Sos_Dunning_OverInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_sos_dunning_over = /** @type {((inputs?: Queue_Sos_Dunning_OverInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Sos_Dunning_OverInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_sos_dunning_over(inputs)
});